// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-header-variants-header-variant-2-topLine-zkfyn{background:var(--color-primary);height:36px}.components-header-variants-header-variant-2-header-bsmdd{margin-bottom:16px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topLine": "components-header-variants-header-variant-2-topLine-zkfyn",
	"header": "components-header-variants-header-variant-2-header-bsmdd"
};
module.exports = ___CSS_LOADER_EXPORT___;
